import { useState } from 'react';
import { Button, MenuItem, Menu } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled, alpha } from '@mui/material/styles';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
    ...theme.applyStyles('dark', {
      color: theme.palette.grey[300],
    }),
  },
}));

const ShareButton = ({
  title = 'Compartir contenido',
  text = 'Mirá esto',
  url = window.location.href,
  children = null,
  buttonProps = {},
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleShare = async () => {
    if (navigator.share) {
      await navigator
        .share({ title, text, url })
        .then(() => {})
        .catch((error) => console.error('Error al compartir:', error));
    }
  };

  return navigator.share ? (
    <Button {...buttonProps} onClick={handleShare}>
      {children || 'Compartir'}
    </Button>
  ) : (
    <>
      <Button
        id='share-button'
        aria-controls={open ? 'share-button' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        {...buttonProps}
      >
        {children || 'Compartir'}
      </Button>
      <StyledMenu
        id='share-button'
        MenuListProps={{
          'aria-labelledby': 'share-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={async (e) => {
            await navigator.clipboard.writeText(url);
            handleClose();
          }}
          disableRipple
        >
          <ContentCopyIcon />
          Copiar enlace
        </MenuItem>
        <MenuItem
          onClick={handleClose}
          disableRipple
          component='a'
          href={`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(
            `${text} ${url}`,
          )}`}
        >
          <EmailIcon />
          E-mail
        </MenuItem>
        <MenuItem
          onClick={handleClose}
          disableRipple
          component='a'
          href={`sms:?body=${encodeURIComponent(`${text} ${url}`)}`}
        >
          <SmsIcon />
          Sms
        </MenuItem>
        <MenuItem
          onClick={handleClose}
          disableRipple
          component='a'
          href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`}
          target='_blank'
          rel='noopener noreferrer'
        >
          <WhatsAppIcon />
          Whatsapp
        </MenuItem>
      </StyledMenu>
    </>
  );
};

export default ShareButton;
